"use client";
import clsx from "clsx";
import type { ReactNode } from "react";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  type?: "checkbox" | "radio";
  disabled?: boolean;
  isVertical?: boolean;
  children?: ReactNode;
  className?: string;
};
export const CheckboxBasic = ({
  children,
  disabled,
  checked,
  onChange,
  type = "checkbox",
  isVertical,
  className,
}: Props) => {
  return (
    <label
      className={clsx(
        className,
        "flex items-center cursor-pointer min-h-[24px] min-w-[24px] relative select-none group",
        {
          "pl-0 pt-8 justify-center": isVertical,
          "pl-8": !isVertical,
        },
      )}
    >
      {children}
      <input
        disabled={disabled}
        className="cursor-pointer opacity-0 absolute"
        type={type}
        checked={checked}
        onChange={() => onChange(!checked)}
      />
      <span
        className={clsx(
          "bg-transparent border border-primary h-6 w-6 absolute after:content-[' '] after:w-[18px] after:h-[18px] after:absolute after:top-0.5 after:left-0.5  group-hover:shadow-xs group-hover:shadow-primary/75",
          {
            "top-0 left-1/2 -translate-x-1/2": isVertical,
            "left-0 top-[calc(50%-12px)]": !isVertical,
            "after:bg-primary": !disabled,
            "after:bg-stone-400": disabled,
            "after:hidden": !checked && !disabled,
            "rounded-full after:rounded-full": type === "radio",
            "rounded-sm after:rounded-sm": type === "checkbox",
          },
        )}
      />
    </label>
  );
};
